<template>
  <div class="coupon-detail">
    <div class="topbar blue-bg" v-show="isRecevie" :class="hide ? 'animated fadeOut' : ''">
      <div class="fx fx-items-center fx-between" v-if="login">
        <div class="fx fx-items-center">
          <van-icon name="passed" size="20" />
          <p>You can check coupons from your Ugift Pocket</p>
        </div>
        <van-button class="blue" type="info" size="small" round @click="hideBar">OK</van-button>
      </div>
      <div class="fx fx-items-center fx-between" v-else>
        <div class="fx fx-items-center">
          <van-icon name="passed" size="20" />
          <p>You can check coupons from your Ugift Pocket after login </p>
        </div>
        <van-button class="blue" type="info" size="small" round @click="toLogin">Login</van-button>
      </div>
    </div>
    <div class="coupons-cnt" :style="{'height': boxHeight}">
      <van-swipe ref="swipe" :loop="false" indicator-color="white" @change="onChange">
        <van-swipe-item v-for="(item, index) in pageData" :key="index">
          <!-- <div class="content">
            <div class="current gray" v-show="totalNum > 1">{{current + 1}}/{{totalNum}}</div>
            <div class="give gray"
              @click="confirmShare(item.voucherId, item.voucherTransferId, item.memberId, item.currency, item.priceReal)"
              v-show="item.voucherStatus != 'Transferred' && !isRecevie">GIFT IT</div>
            <img class="logo" :src="item.goodsItemUrlIco" alt="">
            <div  v-if="item.voucherStatus === 'Init' || item.voucherStatus === 'Using'">
              <p class="name text-center">{{item.goodsItemName}}</p>
            </div>
            <div class="expired" v-if="item.voucherStatus === 'Transferred'">
              <div v-if="dateNow > item.verifyTimeEnd">
                <img class="v-bg" src="../../assets/img/expired.png" alt="">
              </div>
              <div v-else>
                <img class="v-bg" src="../../assets/img/given.png" alt="" v-if="item.voucherStatus === 'Transferred'">
                <img class="v-bg" src="../../assets/img/used.png" alt="" v-if="item.voucherStatus === 'Verified'">
              </div>
              <div class="name text-center">
                <p class="gray">{{item.brandName}}</p>
                <p>{{item.goodsItemName}}</p>
              </div>
              <p class="date">{{item.verifyTimeEnd | dateFormat('minute', '/')}}</p>
            </div>

            <div class="qrcode" v-else>
              <div v-if="item.voucherUrlType.includes('barcode')">
                <img :id="'barcode-img' + index" />
              </div>
              <div class="qrcode-box" v-if="item.voucherUrlType.includes('qrcode')">
                <div class="qr fx fx-center" v-qr="item.voucherQrcode" v-if="item.voucherQrcode" />
                <img src="../../assets/img/UgiftLogoTM.png" alt="">
              </div>
              <div v-if="item.voucherUrlType.includes('codeNumber')">
                <p class="gray text-center">{{item.voucherQrcode}}</p>
              </div>
              <div class="outpage" v-if="item.voucherUrlType.includes('button')">
                <van-button type="info" size="large" round @click="onOutpageTap(item.jumpLink)">To Use</van-button>
              </div>
              <div class="point point-l"></div>
              <div class="point point-r"></div>
            </div>

            <div class="info">
              <div class="group fx fx-between" v-if="item.voucherStatus !== 'Transferred'">
                <p>Purchasing time</p>
                <p class="gray">{{item.createDate | dateFormat('minute', '/')}}</p>
              </div>
              <div class="group fx fx-between" v-if="item.voucherStatus !== 'Transferred' && item.verifyTimeEnd">
                <p>Expiry Date</p>
                <p class="gray">{{item.verifyTimeEnd | dateFormat('day', '/')}}</p>
              </div>
              <div class="group fx fx-between fx-items-center">
                <p>Applicable stores</p>
                <van-icon name="arrow-down" size="16" color="#969799" @click="onCheckTap(item.campaignProductId)"/>
              </div>
              <van-collapse v-model="activeNames" :border="false">
                <van-collapse-item title="Instructions for use" name="1">
                  <p class="gray" style="word-wrap: break-word;" v-html="item.instructions"></p>
                </van-collapse-item>
              </van-collapse>
            </div>
          </div> -->
          <div class="share-btns fx fx-between fx-items-center">
            <img @click="onBackTap" class="back-icon" src="@/assets/img/bar-back.png">
            <div class="give gray"
              @click="confirmShare(item.voucherId, item.voucherTransferId, item.memberId, item.currency, item.priceReal)"
              v-show="item.voucherStatus != 'Transferred' && !isRecevie">GIFT IT</div>
          </div>
          <div class="content">
            <iframe :src="item.templateUrl" width="100%" height="100%"></iframe>
          </div>
        </van-swipe-item>
        <template #indicator v-if="pageData.length > 1">
          <div class="indicator">
            <van-icon
              size="18"
              color="#ffffff"
              name="arrow-left"
              class="prev"
              @click="onPrev"
            />
            <van-icon
              size="18"
              color="#ffffff"
              name="arrow"
              class="next"
              @click="onNext"
            />
          </div>
      </template>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'
export default {
  data () {
    return {
      hide: false,
      login: false,
      activeNames: [1],
      current: 0,
      expiredStyle: {
        'margin-top': '0'
      },
      voucherListParams: {
        token: '',
        packageId: ''
      },
      voucherItemParams: {
        token: '',
        voucherId: '',
        memberId: ''
      },
      pageData: [],
      totalNum: '',
      dateNow: null,
      giveMeParams: {
        voucherId: '',
        orderId: '',
        token: '',
        originalMemberId: ''
      },
      isRecevie: false,
      boxHeight: 0,
      couponsData: [
        {
          link: 'https://paas-ui-static.e-buychina.com/views/cardVoucher/index.html?ticketType=Voucher&ticketId=1230001&data={%22qrcode%22:%2210031212414%22,%22code%22:%2210031212414%22,%22validTime%22:%20%222020-07-31%2010:10:33%22,%22voucherStatus%22:%22Init%22}'
        },
        {
          link: 'https://paas-ui-static.e-buychina.com/views/cardVoucher/index.html?ticketType=Voucher&ticketId=1230001&data={%22qrcode%22:%2210031212414%22,%22code%22:%2210031212414%22,%22validTime%22:%20%222020-07-31%2010:10:33%22,%22voucherStatus%22:%22Abc%22}'
        }
      ]
    }
  },
  created () {
    this.boxHeight = this.$util.getWh() + 50 + 'px'
    this.dateNow = new Date().getTime()
    const queryParams = this.$route.query
    this.isRecevie = queryParams.recevie || ''

    const token = this.$util.storageGet('local', 'token') || ''
    const memberId = this.$util.storageGet('local', 'memberId')
    if (token) {
      if ((queryParams.memberId === memberId) && this.isRecevie) {
        this.$router.replace('/home')
      } else {
        this.login = true
        this.pageInit(token)
      }
    } else {
      this.pageInit()
    }
  },
  watch: {
    pageData (e) {
      if (e.length > 0) {
        this.$nextTick(() => {
          e.map((v, index) => {
            setTimeout(() => {
              const barcodeImg = this.$el.querySelector(`#barcode-img${index}`)
              if (barcodeImg) {
                JsBarcode(barcodeImg, v.voucherQrcode, {
                  height: 40,
                  displayValue: false
                })
              }
            }, 500)
          })
        })
      }
    }
  },
  methods: {
    // 根据包裹ID查券信息
    getPackageItems (params) {
      return this.$http.post('/olvp/getPackageItems', 'getPackageItems', params, true, false)
    },
    // 根据券ID查询券信息
    getVoucherInfo (params) {
      return this.$http.post('/olvp/getVoucherInfo', 'getVoucherInfo', params, true, false)
    },
    // 新领取接口
    newReceiveTransfer (params) {
      return this.$http.post('/olvp/newReceiveTransfer', 'newReceiveTransfer', params, true, false)
    },
    pageInit (token) {
      const queryParams = this.$route.query
      this.giveMeParams.token = token
      this.giveMeParams.orderId = queryParams.orderId || ''
      this.giveMeParams.voucherId = queryParams.voucherId || ''
      this.giveMeParams.originalMemberId = queryParams.memberId
      if (queryParams.type === 'voucher') {
        this.voucherItemParams.token = token || ''
        this.voucherItemParams.voucherId = queryParams.voucherId
        this.voucherItemParams.memberId = queryParams.memberId
        this.loadItemData()
      } else {
        this.voucherListParams.token = token || ''
        this.voucherListParams.packageId = queryParams.packageId
        this.loadListData().then(() => {

        })
      }
    },
    loadListData () {
      return new Promise(resolve => {
        this.getPackageItems(this.voucherListParams).then((d) => {
          if (d.success) {
            this.pageData = d.content.vouchers
            this.totalNum = this.pageData.length
            const phone = this.$util.storageGet('local', 'phone')
            const platformName = this.$util.storageGet('local', 'platform')
            if (this.isRecevie && phone && platformName) { // 转赠进入 放入自己卡包
              this.receive()
            }
          }
          resolve()
        })
      })
    },
    loadItemData () {
      this.getVoucherInfo(this.voucherItemParams).then((d) => {
        if (d.success) {
          this.pageData.push(d.content)
          this.totalNum = 1
          const phone = this.$util.storageGet('local', 'phone')
          const platformName = this.$util.storageGet('local', 'platform')
          if (this.isRecevie && phone && platformName) { // 转赠进入 放入自己卡包
            this.receive()
          }
        }
      })
    },
    onChange (index) {
      this.current = index
      // this.$nextTick(() => {
      //   const barcodeImg = this.$el.querySelector('#barcode-img')
      //   JsBarcode(barcodeImg, this.pageData[index].voucherQrcode, {
      //     height: 40,
      //     displayValue: false
      //   })
      // })
    },
    onPrev () {
      this.$refs.swipe.prev()
    },
    onNext () {
      this.$refs.swipe.next()
    },
    onCheckTap (id) {
      this.$router.push(`/applicableStores?campaignProductId=${id}`)
    },
    goHome () {
      this.$router.replace('/home')
    },
    onOutpageTap (e) {
      window.location.replace(e)
    },
    // 单券转赠确认
    confirmShare (vid, tid, mid, currency, price) {
      this.$util.storageDel('session', 'giftImg')
      this.$util.storageDel('session', 'giftDesc')
      const voucherId = tid || vid
      this.$router.push(`/giveFriends?status=success&self=true&voucherId=${voucherId}&memberId=${mid}&from=order&currency=${currency}&price=${price}`)
    },
    receive () {
      this.newReceiveTransfer(this.giveMeParams).then((d) => {
        if (d.success) {
          this.$cux.toast({
            message: 'The gift coupon has been put into your Ugift wallet.',
            type: 'success'
          })
        }
      })
    },
    // 跳转登录
    toLogin () {
      this.$router.push(`/login?backPath=${encodeURIComponent(this.$route.fullPath)}&memberId=${this.$route.query.memberId}&orderId=${this.$route.query.orderId}`)
    },
    hideBar () {
      this.hide = true
      setTimeout(() => {
        this.isRecevie = false
      }, 300)
    },
    onBackTap () {
      this.$router.back()
    }
  },
  mounted () {

  }
}
</script>

<style lang="scss">
  iframe {
   border: none;
   position: absolute;
   top: -54px;
  }
  .coupon-detail {
    width: 100%;
    min-height: 100%;
    background: #388BFF;
    .topbar {
      color: #fff;
      padding: 15px;
      p {
        margin-left: 6px;
      }
      .van-button {
        background: #fff;
        border: none;
      }
    }

    .res-content {
      padding: 20px;
      .van-button:nth-child(1) {
        margin-bottom: 20px;
      }
    }

    .share-content {
      background: #fff;
      padding: 20px;
      .item {
        margin-right: 20px;
        img {
          width: 50px;
          height: 50px;
          margin: 0 auto;
          margin-bottom: 10px;
        }
      }
    }

    .btns {
      padding: 20px 0;
      .back {
        font-size: 15px;
        margin-top: 20px;
      }
    }

    .current {
      font-size: 18px;
      position: absolute;
      top: 15px;
      left: 15px;
      z-index: 9;
      background: #f7f7f7;
      padding: 2px 8px;
      // border-radius: 5px;
    }
    .coupons-cnt {
      position: relative;
      // top: -20px;
    }
    .share-btns {
      padding: 10px;
      position: relative;
      z-index: 999;
      padding: 10px;
      color: #fff;
      font-size: 16px;
      height: 54px;
      min-height: 54px;
      .give {
        width: 80px;
        font-size: 14px;
        z-index: 9;
        background: #e3eefd;
        color: #4b8cf7;
        padding: 4px 12px;
        border-radius: 20px;
        text-align: center;
      }
    }

    .indicator {
      position: fixed;
      left: 10px;
      right: 10px;
      top: 45%;
      transform: translateY(-50%);
      .van-icon {
        padding: 10px;
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 50%;
      }
      .prev {
        position: absolute;
        left: 0;
      }
      .next {
        position: absolute;
        right: 0;
      }
    }

    .van-swipe {
      height: 100%;
      border-radius: 0 !important;
      position: relative;
    }

    .van-swipe-item {
      position: relative;
    }

    .content {
      height: 100%;
      position: relative;
      background: #fff;
      // padding: 48px 20px 20px 20px;
      // border-radius: 6px;

      .name {
        font-size: 17px;
        margin-bottom: 3px;
        margin-top: 5px;
      }

      .tips {
        font-size: 14px;
      }

      .logo {
        width: 66px;
        height: 66px;
        position: absolute;
        top: -33px;
        left: 50%;
        margin-left: -33px;
        border-radius: 50%;
        z-index: 99;
      }

      .qrcode {
        position: relative;
        padding: 20px 0;
        border-bottom: 1px dashed #ccc;
        .qrcode-box {
          position: relative;
          img {
            width: 40px;
            height: 40px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .qr {
          margin-bottom: 10px;
          margin-top: 20px;
          canvas {
            width: 160px;
            height: 160px;
          }
        }
        .outpage {
          width: 70%;
          margin: 0 auto;
          display: block;
          padding: 40px 0;
        }
        p {
          font-size: 20px;
        }

        .point {
          width: 18px;
          height: 18px;
          background: #f7f7f7;
          position: absolute;
          bottom: -9px;
          border-radius: 50%;
        }

        .point-l {
          left: -30px;
        }

        .point-r {
          right: -30px;
        }

        .code-img {
          width: 160px;
          height: 160px;
          margin: 0 auto;
          margin-bottom: 10px;
          margin-top: 10px;
        }
      }

      .expired {
        position: relative;
        margin-top: 15px;
        .v-bg {
          height: 100%;
        }

        .name {
          font-size: 16px;
          padding-bottom: 10px;
          border-bottom: 1px dashed #ccc;
          position: absolute;
          top: 15px;
          left: 20px;
          width: 68%;
          p:nth-child(1) {
            font-size: 14px;
            margin-bottom: 3px;
          }
        }

        .date {
          font-size: 14px;
          position: absolute;
          top: 80px;
          left: 20px;
        }
      }

      .info {
        padding-top: 14px;
        position: relative;

        .group {
          padding: 8px 0;

          p {
            font-size: 15px;
          }

          .gray {
            font-size: 14px;
          }

          .van-button {
            background: rgba(56, 139, 255, 0.15);
            color: #388BFF;
            border: none;
            font-size: 15px;
          }
        }
      }

      .van-collapse {
        .van-cell {
          padding-left: 0;
          padding-right: 0;
          padding-top: 8px;
          font-size: 15px;
        }
        .van-collapse-item__wrapper {
          .van-collapse-item__content {
            padding-left: 0;
            padding-right: 0;
            line-height: 25px;
            font-size: 14px;
          }
        }
      }

    }
  .back-icon {
      width: 9px;
      height: 16px;
    }
  }
</style>
